import { ref } from 'vue';
import { defineStore } from 'pinia';
import { applyPatch } from 'fast-json-patch';

export const useItemEngineStateStore = defineStore('itemEngineStateStore', () => {
    const itemEngineStates = ref({});

    function addItemEngineState(itemEngineStateModel) {
        itemEngineStates.value[itemEngineStateModel.id] = itemEngineStateModel;
    }

    function updateItemEngineState(id, itemEngineStateModel) {
        itemEngineStates.value[id] = itemEngineStateModel;
    }

    function removeItemEngineState(id) {
        delete itemEngineStates.value[id];
    }

    function applyJsonPatch(id, jsonPatch) {
        applyPatch(itemEngineStates.value[id], jsonPatch, false, true);
    }

    return {
        itemEngineStates,
        addItemEngineState,
        updateItemEngineState,
        removeItemEngineState,
        applyJsonPatch
    }
})